import { isEmpty } from "lodash";
import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ReviewStars from "./ReviewStars";
import { PATHOGENICITY_COLORS_BY_STRING } from "../../common/helpers/Constant";
import {
  getVarsomeHost,
  getVariantSpec,
} from "../../state/selectors/general.selectors";
import { getRefGenomeName } from "./selectors/ProteinViewer.selectors";

const TableBase = ({
  codonRelevantInformation,
  hostUrl,
  refGenome,
  variantSpec,
  isFullScreen,
}) => {
  if (isEmpty(codonRelevantInformation.flat())) return null;
  const positionRegex = /(([a-zA-Z]{3}\d{1,2})|([a-zA-Z]{3}[A-Za-z])):[0-9]+/;
  // This regex will extract the chrX:20123122 or chr22:20123122 part.
  const mapRealSourceToApiSources = {
    "NCBI ClinVar2": "ClinVar",
    "UNIPROT UniProt Variants": "UniProt",
    "Saphetor PubMedUserEntry": "Saphetor PubMedUserEntry",
    "Saphetor VarSome Comment": "Saphetor VarSome Comment",
  };

  return (
    <div className="tw-mt-4">
      <div
        className={isFullScreen ? "tw-overflow-auto tw-max-h-3dProtMax" : ""}
        style={{ maxHeight: "590px" }}
      >
        <table className=" table">
          <thead>
            <tr>
              <th className="tw-font-bold">Germline Variant Classification</th>
              <th className="tw-font-bold">Codon</th>
              <th className="tw-font-bold">Variant</th>
              <th className="tw-font-bold">Transcript</th>
              <th className="tw-font-bold">HGVS</th>
              <th className="tw-font-bold">Review Stars</th>
              <th className="tw-font-bold">Source</th>
            </tr>
          </thead>
          <tbody>
            {codonRelevantInformation.reverse().map((pathoArray) => {
              if (pathoArray.length > 1) {
                pathoArray
                  .sort((c, d) =>
                    c.hgvs.localeCompare(d.hgvs, "en", { numeric: true })
                  )
                  .sort(
                    (a, b) =>
                      parseInt(
                        positionRegex.exec(a.pretty_spec)[0].split(":")[1],
                        10
                      ) -
                      parseInt(
                        positionRegex.exec(b.pretty_spec)[0].split(":")[1],
                        10
                      )
                  );
              }
              return (
                !isEmpty(pathoArray) &&
                pathoArray.map((pathoInfo, index) => {
                  return (
                    <>
                      <tr
                        key={`${pathoInfo}-${pathoInfo?.acmg_class}-${pathoInfo?.codon}-${pathoInfo?.spec}-${index}`}
                        className={
                          variantSpec === pathoInfo?.spec
                            ? "tw-bg-yellow-100"
                            : ""
                        }
                      >
                        <td
                          className="tw-font-bold"
                          style={{
                            color:
                              PATHOGENICITY_COLORS_BY_STRING[
                                pathoInfo?.acmg_class
                              ],
                          }}
                        >
                          {pathoInfo?.acmg_class}
                        </td>
                        <td>{pathoInfo?.codon}</td>
                        <td>
                          <a
                            href={`${hostUrl}/variant/${refGenome}/${pathoInfo?.spec}`}
                            target="_blank"
                          >
                            {pathoInfo?.pretty_spec}
                          </a>
                        </td>
                        <td>
                          <a
                            target="_blank"
                            href={`${hostUrl}/transcript/${refGenome}/${pathoInfo?.transcript}`}
                          >
                            {pathoInfo?.transcript}
                          </a>
                        </td>
                        <td>{pathoInfo?.hgvs}</td>
                        <td>
                          {pathoInfo?.source === "NCBI ClinVar2" ? (
                            <ReviewStars totalStars={pathoInfo?.review_stars} />
                          ) : null}
                        </td>
                        <td>
                          {mapRealSourceToApiSources[pathoInfo?.source] ||
                            pathoInfo?.source}
                        </td>
                      </tr>
                    </>
                  );
                })
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

TableBase.propTypes = {
  hostUrl: PropTypes.string,
  refGenome: PropTypes.string,
  codonRelevantInformation: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        acmg_class: PropTypes.string,
        coding_impact: PropTypes.string,
        codon: PropTypes.number,
        gene_symbol: PropTypes.string,
        hgvs: PropTypes.string,
        pretty_spec: PropTypes.string,
        source: PropTypes.string,
        spec: PropTypes.string,
        review_stars: PropTypes.number,
        transcript: PropTypes.string,
        variant_id: PropTypes.string,
      })
    )
  ),
  variantSpec: PropTypes.string,
  isFullScreen: PropTypes.bool.isRequired,
};

TableBase.defaultProps = {
  hostUrl: null,
  refGenome: null,
  codonRelevantInformation: null,
  variantSpec: null,
};

const mapStateToProps = (state) => ({
  hostUrl: getVarsomeHost(state),
  refGenome: getRefGenomeName(state),
  variantSpec: getVariantSpec(state),
});
export default connect(mapStateToProps)(TableBase);
